import { ActionPayload } from "../types/working-model";

import { PostHv } from "./helpers";

export function SendTrackingEvent(trackingData: ActionPayload, token: string): Promise<any> {
	return PostHv('/actions', trackingData, token, true);
}
